/**
 * @deprecated Do not use!
 *
 * Use GCTL instead:
 * import { Membership } from '@vimeo/gctl-api/models/components/schemas/membership/Membership';
 * type AccountType = Membership['type'];
 */
export enum AccountType {
  Advanced = 'advanced',
  Basic = 'basic',
  Business = 'business',
  Enterprise = 'enterprise',
  Free = 'free',
  LiveBusiness = 'live_business',
  LivePremium = 'live_premium',
  LivePro = 'live_pro',
  Plus = 'plus',
  Pro = 'pro',
  ProUnlimited = 'pro_unlimited',
  Standard = 'standard',
  Starter = 'starter',
}

/**
 * @deprecated Do not use!
 *
 * Use GCTL instead:
 * import { User } from '@vimeo/gctl-api/models/components/schemas/user/User';
 * type QuotaUnit = User['uploadQuota']['space']['unit'];
 */
export type QuotaUnit = 'video_count' | 'video_size';

/**
 * @deprecated Do not use!
 *
 * A note about the `unit` property in the UploadQuota type below:
 * It's not actually optional. It will always be included in the upload quota
 * response. It's listed as optional below only because adding it broke everything
 * where we are currently mocking the user, which is dozens of files.
 *
 * The UploadQuota interface is already not a faithful representation of the object
 * returned from the API. Use GCTL instead:
 *
 * import { User } from '@vimeo/gctl-api/models/components/schemas/user/User';
 * type UploadQuota = User['uploadQuota'];
 */
export interface UploadQuota {
  space: {
    free: number;
    used: number;
    max: number;
    showing: string;
    unit?: QuotaUnit;
  };
  lifetime: {
    free: number | null;
    used: number | null;
    max: number | null;
    unit?: QuotaUnit;
  };
  periodic: {
    free: number | null;
    used: number | null;
    max: number | null;
    resetDate: string | null;
    unit?: QuotaUnit;
    period?: 'week' | 'month' | 'year' | 'lifetime';
  };
}

/**
 * @deprecated Do not use!
 *
 * Use GCTL instead:
 * import { User } from '@vimeo/gctl-api/models/components/schemas/user/User';
 * type Metadata = User['metadata'];
 */
export interface Metadata {
  connections: {
    videos: {
      total: number;
    };
    connectedApps: {
      total: number;
    };
  };
}

/**
 * @deprecated Do not use!
 *
 * Use GCTL instead:
 * import { User } from '@vimeo/gctl-api/models/components/schemas/user/User';
 * type Pictures = User['pictures'];
 */
export interface Picture {
  type?: 'default' | 'custom' | 'caution';
  sizes: {
    width: number;
    height: number;
    link: string;
  }[];
}

/**
 * @deprecated Do not use!
 *
 * Use GCTL instead:
 * import { Membership } from '@vimeo/gctl-api/models/components/schemas/membership/Membership';
 * type BadgeType = Membership['badge']['type'];
 */
export enum BadgeType {
  Alum = 'alum',
  Business = 'business',
  Curation = 'curation',
  LiveBusiness = 'live_business',
  LivePremium = 'live_premium',
  LivePro = 'live_pro',
  Plus = 'plus',
  Potus = 'potus',
  Pro = 'pro',
  Producer = 'producer',
  Sponsor = 'sponsor',
  Staff = 'staff',
  Support = 'support',
}

/**
 * @deprecated Do not use!
 *
 * Use GCTL instead:
 * import { Membership } from '@vimeo/gctl-api/models/components/schemas/membership/Membership';
 * type Badge = Membership['badge'];
 */
export interface Badge {
  alt_text: string;
  text: string;
  type: BadgeType;
  url: string;
}

/**
 * @deprecated Do not use!
 *
 * Use GCTL instead:
 * import { Location } from '@vimeo/gctl-api/models/components/schemas/location/Location';
 */
export interface Location {
  city?: string;
  country?: string;
  countryIsoCode?: string;
  state?: string;
  stateIsoCode?: string;
  formattedAddress: string;
  latitude: number;
  longitude: number;
  neighborhood?: string;
  placeId?: string;
  placeProvider?: string;
  subLocality?: string;
}

/**
 * @deprecated Do not use!
 *
 * There is no GCTL equivilant for this, since it's not a property on the User model.
 * You could technically do...
 *
 * import { Location } from '@vimeo/gctl-api/models/components/schemas/location/Location';
 * type BasicLocation = Pick<Location, 'formattedAddress', 'placeId'>;
 *
 * ...but again, this type feels like it shouldn't be tied to our API responses.
 */
export interface BasicLocation {
  formattedAddress: string;
  placeId: string;
}

/**
 * @deprecated Do not use!
 *
 * Use GCTL instead:
 * import { Skill } from '@vimeo/gctl-api/models/components/schemas/skill/Skill';
 */
export interface Skill {
  uri: string;
  name: string;
}

/**
 * @deprecated Do not use!
 *
 * Use GCTL instead:
 * import { VimeoExperts } from '@vimeo/gctl-api/models/components/schemas/vimeo-experts/VimeoExperts';
 */
export interface VimeoExpert {
  status: string | null;
}

/**
 * @deprecated Do not use!
 *
 * Use GCTL instead:
 * import { TeamMembership } from '@vimeo/gctl-api/models/components/schemas/team-membership/TeamMembership';
 * type TeamUserPermissionLevel = TeamMembership['permissionLevel'];
 */
export enum TeamUserPermissionLevel {
  Owner = 'Owner',
  Admin = 'Admin',
  Contributor = 'Contributor',
  ContributorPlus = 'Contributor Plus',
  Uploader = 'Uploader',
  Viewer = 'Viewer',
}

/**
 * This is the data included in the `user` property of the Viewer object. It is
 * _not_ the API representation of a `User`. If you are looking for the API
 * `User` object, import from `@vimeo/gctl-api/models/components/schemas/user/User`
 * instead.
 *
 * The `ViewerUser` is a weird amalgamation of the API user representation and a
 * hodge podge of other stuff tacked on for convience. DO NOT ADD TO THIS. ONLY
 * REMOVE FROM IT.
 *
 * See `Viewer.php` for details.
 */
export interface User {
  id: number;
  account: AccountType;
  badge: Badge;
  createdTime: string | null;
  metadata: Metadata;
  name: string;
  uploadQuota: UploadQuota;
  link: string;
  pictures: Picture;
  uri: string;
  capabilities: UserCapability;
  email?: string;
  showAvailableForHire?: boolean;
  showViewEditProfile?: boolean;
  locationResponse?: Location;
  skills?: Skill[];
  isTeamUser: boolean;
  isFreeTrial?: boolean;
  teamUserPermissionLevel: TeamUserPermissionLevel | null;
  managedUser?: {
    id: number;
    token: string;
    app: { id: number; clientId: string };
    isConverted: boolean;
  };
  profilePreferences?: {
    profileType: string | null;
  };
  vimeoExpert?: VimeoExpert;
  preferences?: {
    webinarRegistrantLowerWatermarkBannerDismissed: object;
  };
  survey?: Survey;
  isSuperUser?: boolean;
  hasActiveVideo?: boolean;
  highBandwidthNotification?: boolean;
  organizationId?: string;
}

/**
 * This is the Team object assembled as part of the `Viewer` object in `Viewer.php`.
 * This is unrelated to our API response objects.
 */
export interface Team {
  currentTeamSize: number;
  maxTeamSize: number;
  avatar: {
    src: string;
    srcSet: string;
  };
  remainingInviteCount: number;
  ownerId?: number;
  teamLogoUrl?: string;
}

/**
 * @deprecated Do not use!
 *
 * Use types from the `useCapability` hook instead:
 * import { UserCapabilities } from '@vimeo/core/hooks/use-capability';
 *
 * This is backed by GCTL.
 */
export interface UserCapability {
  canSwitchAccounts: boolean;
  canAddTeamMembers: boolean;
  canAddFolderViewerTeamMembers: boolean;
  canBatchEdit: boolean;
  canCreateAlbums: boolean;
  canCreateEmbeddedPlaylists: boolean;
  canCreateLiveEvents: boolean;
  canCreatePortfolios: boolean;
  canCustomizeAlbums: boolean;
  canEditFolders: boolean;
  canEditPersonalInfo: boolean;
  canInviteToFolder: boolean;
  canSeeResourceShareModalUiUpdates: boolean;
  canManageTeamCollections: boolean;
  canPublishToSocial: boolean;
  canReceiveFreeStock: boolean;
  canSearchAllVideos: boolean;
  canSearchAndRespondToMarketplaceJobs: boolean;
  canUnlistVideo: boolean;
  canUpgrade: boolean;
  canUseBelugaSearch: boolean;
  canUseModWorld: boolean;
  canAccessVimeoExperts: boolean;
  canCreateWebinar: boolean;
  canUsePaymentsService: boolean;
  hasUpsellsForFlatRateTiers: boolean;
  hasBasic: boolean;
  hasBusiness: boolean;
  hasCreation: boolean;
  hasEnterprise: boolean;
  hasFreeTrialEligibility?: boolean;
  hasLiveBusiness: boolean;
  hasLivePremium: boolean;
  hasLivePro: boolean;
  hasLiveSubscription: boolean;
  hasPaid: boolean;
  hasPlus: boolean;
  hasPro: boolean;
  hasProCustom: boolean;
  hasProducer: boolean;
  hasProUnlimited: boolean;
  hasContentSpaceEnabled: boolean;
  hasShowcaseLiveLayout: boolean;
  hasShowcaseStatsPage: boolean;
  hasShowcaseSeoPage: boolean;
  hasShowcaseTeamPrivacy: boolean;
  hasShowcaseLivePublicOnly: boolean;
  hasShowcaseUpsellsRollout: boolean;
  hasStockEnterprise: boolean;
  hasTeamSettings: boolean;
  hasVideoManagerAd: boolean;
  hasVideoManagerSettingsTest: boolean;
  hasBeenInFreeTrial?: boolean;
  hasVideoLibrary: boolean;
  hasEnterpriseLihp: boolean;
  hasLiveEventLeadUpsell: boolean;
  hasSimplifiedEnterpriseAccount?: boolean;
  hasPerSeatPricingModelTeamMember: boolean;
  hasMarketingSettings: boolean;
  hasDataRetention: boolean;
  hasLegalHoldsActive: boolean;
  canViewAuditLogs: boolean;
}

/**
 * This is the TeamUser assembled as part of the `Viewer` object in `Viewer.php`.
 * This is unrelated to our API response objects.
 */
export interface TeamUser {
  ownerId: number;
  userId: number;
  permissionLevel: number;
  hasPaid: boolean;
  hasPlus: boolean;
  hasPro: boolean;
  plainTextPermissionLevel: string;
  hasLiveSubscription: boolean;
  hasLivePermissionGrant: boolean;
  imageUrl: string;
  displayName: string;
  hasPerSeatPricingModelTeamMember: boolean;
  currentTeamSize: number;
  maxTeamSize: number;
  hasContentSpaceEnabled: boolean;
  accountType: AccountType;
  joinedOn: string;
  teamId: number;
  isFreeTrial?: boolean;
  ownerHasActiveVideo?: boolean | null;
  ownerIsSuperUser?: boolean | null;
  publishToSocialRestricted: boolean;
  enterpriseSiteDomain?: string;
  ownerTeamSeatsMode?: 'admin_and_authenticated' | 'global' | 'per_seat_type';
}

export interface DesktopRegAnswer {
  id: string;
  label?: string;
  isSelected?: boolean;
  placeholder?: string;
}

export interface DesktopRegQuestion {
  id: string;
  isMultiChoice?: boolean;
  question: string;
  placeholder?: string;
  answers?: DesktopRegAnswer[];
}

export interface DesktopRegSurvey {
  surveyType?: string;
  isCompleted?: boolean;
  shouldShow?: boolean;
  questions?: DesktopRegQuestion[];
}

export interface Survey {
  desktopReg?: DesktopRegSurvey;
  welcomeSurvey?: WelcomeSurveyEntry[];
}

export interface WelcomeSurveyEntry {
  questionId?: string;
  answerId?: string;
}
